import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[formControlGrid]'
})
export class FormControlGridDirective implements AfterViewInit {

  @Input() formField!: any;


  constructor(private readonly renderer: Renderer2, private readonly el: ElementRef) {}


  public ngAfterViewInit() {
    let className = 'col-md-4';
     if (this.formField.configuration?.length) {
        if (this.formField.configuration[0].field_size === "small") {
          this.formField.control_type === 'button' ? className = 'col-md-2' : className = 'col-md-4';
        }
        else if (this.formField.configuration[0].field_size === "medium") {
          className = 'col-md-6';
        }
        else if (this.formField.configuration[0].field_size === "large") {
          className = 'col-md-12';
        }
        if (this.formField.control_type === 'button') {
          this.renderer.addClass(this.el.nativeElement, 'form-btn-layout');
        }
      }
    this.renderer.addClass(this.el.nativeElement, className);
  }

}